'use strict';

var $ = require('jquery');
var Radio = require('backbone.radio');
var Marionette = require('backbone.marionette');
var polyglot = require('../../utilities/polyglot').default;
var Tracker = require('../../../analytics/events').default;

var urls = require('../../utilities/urls').default;
var StepTitleView = require('../step-title').default;
var Request = require('../../models/request').default;
var EmptyView = require('../waitlist/no-request').default;
var RequestDetailsView = require('../waitlist/request-details').default;
var PreferenceCollection = require('../../collections/preferences').default;

export default Marionette.View.extend({

  className: 'l-waitlist-confirmation',
  template: require('./templates/waitlist-confirmation.hbs'),
  regions: {
    title: '.l-waitlist-confirmation-title',
    body: '.l-waitlist-confirmation-body',
  },

  initialize: function (options) {
    Tracker.trackView('waitlist-confirmation');
    var message = window.localStorage.getItem('waitlistConfirmationMessage');
    if (message) {
      window.localStorage.removeItem('waitlistConfirmationMessage');
    }
    this.showMessage = message || '';
    this.attempt = urls.getParam('avail') || false;
    this.request = new Request(options.request);
    this.initializeBodyView();

    this.listenTo(Radio.channel('waitlist-confirmation'), 'renderUpdatedRequest', this.renderUpdatedRequest);
    this.listenTo(Radio.channel('confirm-request-cancel'), 'confirm:cancel', this.onCancelConfirmed);
    this.showCookieMessage();
  },

  initializeBodyView: function () {
    var noRequest = true;
    if (this.request && !this.request.get('appointment_id')) {
      if (this.request.isActive()) {
        noRequest = false;
        this.request.set('preferences', new PreferenceCollection(this.request.get('preferences')));
        this.bodyView = new RequestDetailsView({
          showMessage: this.showMessage,
          request: this.request,
          attempt: this.attempt,
        });
      } else {
        this.request.set('active', false);
      }
    }

    if (noRequest) {
      this.bodyView = new EmptyView({
        message: this.request && this.request.get('appointment_id') ?
          polyglot.t('pages.waitlist_confirmation.booked') :
          polyglot.t('pages.waitlist_confirmation.no_request'),
      });
    }
  },

  serializeData: function () {
    return {
      bookLink: window.location.pathname,
    };
  },

  onRender: function () {
    this.showChildView('title', new StepTitleView({
      title: polyglot.t('pages.waitlist_confirmation.title'),
    }));
    this.showChildView('body', this.bodyView);
  },

  renderUpdatedRequest: function (data, showMessage) {
    if (showMessage) {
      this.showMessage = showMessage;
    }
    this.request = new Request(data);
    this.initializeBodyView();
    this.render();
  },

  showCookieMessage: function () {
    if (!$.cookie('cookiesAccepted')) {
      Radio.channel('long-toast').trigger('show', {
        message: polyglot.t('messages.cookies'),
        modalSize: 'large',
        buttonMessage: polyglot.t('messages.cookies_confirm'),
        buttonClass: 'cookie',
        showIcon: false,
      });
    }
  },

  /**
   * Shows errors if invalid, else continues the cancellation chain.
   *
   * @param childView
   */
  onCancelConfirmed: function (childView) {
    var exists, open;
    childView.hideErrors();
    this.request.isValidRequest().done(function (r) {
      var returned = new Request(r.data.request);
      exists = returned.isNotCancelled();
      open = returned.isNotBooked();
    }).fail(function () {
      exists = false;
    }).always(function () {
      if (exists && open) {
        childView.model.cancel().done(function () {
          Radio.channel('complete-request-cancel').trigger('complete:cancel');
        });
      } else {
        if (!exists) {
          childView.ui.cancelMsg.after('<div class="form-error">' + polyglot.t(
            'pages.waitlist_confirmation.already_cancelled') + '</div>');
        } else if (!open) {
          childView.ui.cancelMsg.after('<div class="form-error">' + polyglot.t(
            'pages.waitlist_confirmation.booked') + '</div>');        }
      }
    });
  },

});
